import { useRegisterOptionsStore } from "~/stores/get-register-options-data";

async function getProfile(locale:string) {
  const { data, error, pending } = await useFetch("/api/auth", {
    method: "POST",
    body: {
      type: "getProfile",
      payload: useCookie("customer_id").value,
      locale: locale,
    },
  });

  if (!error.value && !pending.value) {
    return data.value?.data?.customer;
  } else {
    return [];
  }
}

async function mapProfileData(profile: any) {
  const registerOptionsStore = useRegisterOptionsStore();

  let province = null;
  if (profile?.customer_province) {
    await registerOptionsStore.getProvince();
    const provinceOptions = registerOptionsStore.provinceOptions;
    province = provinceOptions.find((p: any) => {
      return p.value == profile?.customer_province;
    });
  }

  if (province) {
    province = province.province;
  }

  return {
    name: profile?.customer_name,
    surname: profile?.customer_surname,
    status: profile?.status,
    cardCode: profile?.card_number,
    date_of_birth: profile?.customer_birthday,
    gender: profile?.customer_gender,
    email: profile?.email,
    cel: profile?.customer_cell_phone,
    address: profile?.customer_address,
    cap: profile?.customer_zip,
    province: province,
    expected_birth_date: profile?.child_birthday_upcoming,
    consent: {
      optIn0: profile?.gdpr_privacy,
      optIn1: profile?.gdpr_newsletter,
      optIn2: profile?.gdpr_profiling,
      optIn3: profile?.gdpr_marketing_analysis,
      optIn4: profile?.gdpr_contest_opt_in,
      optIn5: profile?.gdpr_external_consent,
    },
    children: profile?.customer_childrens,
  };
}

export { getProfile, mapProfileData };
